export const tabConfig = {
  assemblies: {
    value: 'assemblies',
    label: 'Aufbauten',
  },
  connections: {
    value: 'connections',
    label: 'Zugverbindungen',
  },
  shearConnections: {
    value: 'shearConnections',
    label: 'Schubverbinder',
  },
  defaultCrossSections: {
    value: 'defaultCrossSections',
    label: 'Standardquerschnitte',
  },
  components: {
    value: 'components',
    label: 'Bauteile',
  },
  projectFields: {
    value: 'projectFields',
    label: 'Projektkonfiguration',
  },
  plansDocumentation: {
    value: 'plansDocumentation',
    label: 'Pläne & Dokumentation',
  },
  aiInstructions: {
    value: 'aiInstructions',
    label: 'KI-Instruktionen',
  },
}
